
import { Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface OrderItem {
  product_name: string;
  variant_size: string;
  variant_color: string;
  quantity: number;
  unit_price: number;
  total_price: number;
  product_id: string;
}

interface OrderItemsListProps {
  items: OrderItem[];
}

export const OrderItemsList = ({ items }: OrderItemsListProps) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-gray-900">Articles commandés</h2>
      <div className="bg-white rounded-lg border divide-y">
        {items.map((item, index) => (
          <div key={index} className="p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
            <div className="flex-1">
              <h3 className="font-medium text-gray-900">{item.product_name}</h3>
              <p className="text-sm text-gray-500">
                Taille: {item.variant_size} - Couleur: {item.variant_color}
              </p>
              <p className="text-sm text-gray-500">
                Quantité: {item.quantity} × {item.unit_price.toFixed(2)} CAD
              </p>
            </div>
            <div className="sm:text-right">
              <p className="font-medium text-gray-900">
                {item.total_price.toFixed(2)} CAD
              </p>
              <Button
                variant="ghost"
                size="sm"
                className="mt-1 sm:mt-2 px-0 sm:px-3 h-auto py-1"
                onClick={() => navigate(`/product/${item.product_id}`)}
              >
                <Eye className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
                <span className="text-xs sm:text-sm">Voir le produit</span>
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
